import numeral from "numeral";
import { useMemo } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { cn } from "../../../utils/useFunctions";
import ListDebtMain from "../../balance/component/VIListDebt";
import {
  options_expenses_fixed,
  options_other_income
} from "../../balance/functions";
import {
  PdfBalanceHeaderItemCard,
  PdfBalanceItemCard,
  PdfCard,
  PdfCardGray,
  PdfCardWhite,
} from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import {
  PdfHeaderCardText,
  PdfHeaderText,
} from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  calExpenseFixedOption,
  calIncomeInterestOtherOption,
  getBalanceItems
} from "../lib/pdf.lib";
import {
  STYLE_PAGE
} from "../styles/pdf.style";

function PdfPageBalananceFive({ page }) {
  const balanceData = useBalanceStore((state) => state.balanceData);

  const mergeOptions = useMemo(() => {
    return [
      {
        label: "เงินผ่อนชำระงวดหนี้สินคงค้าง",
        key: "expenses_fixed_list",
        key_option: "options_expenses_fixed",
        options: options_expenses_fixed,
        icon: "accounting.svg",
        calLocalOption: calExpenseFixedOption,
        calLocalMonthOption: () => {
          return 0;
        },
      },
    ];
  }, [balanceData]);

  const propertyIncomeItems = useMemo(() => {
    const tempPropertyItems = getBalanceItems(balanceData, []);
    const newPropertyItems = [];

    let lastItem = {
      amount_per_year: 0,
      amount_per_month: 0,
      label: "รวม",
      returns: 100,
    };

    let salaryItem = {
      amount_per_year: 0,
      amount_per_month: 0,
      label: "เงินเดือน",
      returns: 0,
    };

    if (balanceData?.salary_peryear_list?.length > 0) {
      for (const salary_peryear_item of balanceData.salary_peryear_list) {
        salaryItem.amount_per_year += +salary_peryear_item.amount;
        salaryItem.amount_per_month += +salary_peryear_item.salary_permonth;
        lastItem.amount_per_year += +salary_peryear_item.amount;
        lastItem.amount_per_month += +salary_peryear_item.salary_permonth;
      }
    }

    newPropertyItems.push(salaryItem);

    for (const tempPropertyItem of tempPropertyItems) {
      const items = tempPropertyItem.items;
      for (const item of items) {
        if (item.label === "รวม") {
          continue;
        }
        lastItem.amount_per_year += item.amount_per_year;
        lastItem.amount_per_month += item.amount_per_month;
        newPropertyItems.push(item);
      }
    }

    for (const newPropertyItem of newPropertyItems) {
      newPropertyItem.returns =
        (newPropertyItem.amount_per_year / lastItem.amount_per_year) * 100;
    }

    newPropertyItems.push(lastItem);
    return [
      {
        label: "เงินเดือน",
        icon: "salary_pdf.svg",
        items: newPropertyItems,
      },
    ];
  }, [balanceData]);

  const propertyIncomeBonusItems = useMemo(() => {
    const tempPropertyItems = getBalanceItems(balanceData, [
      {
        label: "โบนัส",
        key: "other_income_list",
        key_option: "option_income_other",
        options: options_other_income,
        icon: "credit-card.svg",
        calLocalOption: calIncomeInterestOtherOption,
      },
    ]);
    const newPropertyItems = [];

    let lastItem = {
      amount_per_year: 0,
      amount_per_month: 0,
      label: "รวม",
      returns: 100,
    };

    if (balanceData?.other_income_list?.length > 0) {
      for (const salary_peryear_item of balanceData.other_income_list) {
        lastItem.amount_per_year += +salary_peryear_item.other_income_peryear;
      }
    }

    for (const tempPropertyItem of tempPropertyItems) {
      const items = tempPropertyItem.items;
      for (const item of items) {
        if (item.label === "รวม") {
          continue;
        }
        newPropertyItems.push(item);
      }
    }

    for (const newPropertyItem of newPropertyItems) {
      newPropertyItem.returns =
        (newPropertyItem.amount_per_year / lastItem.amount_per_year) * 100;
    }

    newPropertyItems.push(lastItem);
    return [
      {
        label: "โบนัส",
        icon: "baht.svg",
        items: newPropertyItems,
      },
    ];
  }, [balanceData]);

  const propertyItems = useMemo(() => {
    return getBalanceItems(balanceData, mergeOptions);
  }, [balanceData]);

  const total = useMemo(() => {
    let total = 0;
    for (const propertyItem of propertyIncomeItems) {
      for (const item of propertyItem.items) {
        if (item?.label === "รวม") continue;
        total += item.amount_per_year;
      }
    }
    return total;
  }, [propertyIncomeItems]);

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText title="รายรับ-รายจ่าย" icon="/images/balance.svg" />

      <PdfCard title={"รายจ่าย"}>
        {/* เงินผ่อนชำระงวดหนี้สินคงค้าง */}
        <PdfCardWhite className={"flex flex-col"}>
          <PdfHeaderCardText
            title="รวมรายจ่ายทั้งหมด"
            titleEnd={`${numeral(balanceData?.expenses_propotion).format(
              "0,0"
            )} บาท`}
            icon=""
            classNameRoot="mt-2"
          />

          <ListDebtMain showTotal={false} />

        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageBalananceFive;
